<template>
  <div class="map-fullscreen" @click="$emit('click')">
    <div class="map-fullscreen--icon" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component()
export default class FullScreenButton extends Vue {

}
</script>

<style lang="scss">
.map-fullscreen {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  padding: 5px;
  background-color: #fff;

  &--icon {
    background: url('/assets/images/Maps/Listingmap/icons/MapFullScreen.svg');
    background-repeat: 'no-repeat';
    background-position: 'center';
    width: 100%;
    height: 100%;
  }

  &--exit {
    display: none;
    z-index: 10000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/googleMap/buttons/FullScreen.vue